import React from 'react'
import cx from 'classnames'
import { Message } from 'sb-react-intl'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import Icon, { IconName } from 'components/_new/ui/Icon/Icon'

import s from './ItemView.scss'


type ItemViewProps = {
  message: ReactIntlMessage | string
  iconName?: IconName
  emojiIcon?: string
  level?: number
  isActive?: boolean
  isOpen?: boolean
  hasSubNav?: boolean
}

const ItemView: React.FunctionComponent<ItemViewProps> = ({ message, iconName, emojiIcon, level, isActive, isOpen, hasSubNav }) => {
  const rootClassName = cx(s.item, {
    [s[`level-${level}`]]: s[`level-${level}`],
    [s.highlight]: isActive && !isOpen,
    [s.opened]: hasSubNav && isOpen,
  })

  const textSize    = level === 1 ? '20-24' : '16-24'
  const color       = isActive ? 'brand' : 'black'
  const isSemibold  = Boolean(level > 1 && !isOpen)
  const isBold      = Boolean(level > 1 && hasSubNav && isOpen)

  const chevronColor = isActive ? 'brand' : (isOpen ? 'black' : 'gray')

  return (
    <Box className={rootClassName} pt={12} pb={12} pl={16} pr={16}>
      {
        Boolean(iconName) && (
          <Icon className={s.icon} name={iconName} color={color} />
        )
      }
      <Text
        className={s.text}
        size={textSize}
        color={color}
        semibold={isSemibold}
        align="left"
        bold={isBold}
      >
        {
          Boolean(emojiIcon) && (
            <span>{emojiIcon} </span>
          )
        }
        <Message text={message} />
      </Text>
      {
        Boolean(hasSubNav) && (
          <Icon className={s.chevron} name="bottomArrowSmall" color={chevronColor} />
        )
      }
    </Box>
  )
}


export default ItemView
